// extracted by mini-css-extract-plugin
module.exports = {"controls":"Controls_controls__1r8sA","button":"Controls_button__2LcPm","settingsBtn":"Controls_settingsBtn__2k9Ii"};